import React, { Component } from 'react';

class TextInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value || '',
      cursor: 0
    };
  }

  componentDidUpdate(prevProps) {
    // Update the value from props if it changes
    if (prevProps.value !== this.props.value) {
      this.setState({ value: this.props.value });
    }
    // Restore the cursor position after the update
    if (this.input) {
      this.input.selectionStart = this.input.selectionEnd = this.state.cursor;
    }
  }

  handleChange = (e) => {
    // Get the new value and cursor position from the event
    const value = e.target.value;
    const cursor = e.target.selectionStart;
    // Update the state and call the onChange prop
    this.setState({ value, cursor }, () => {
      if (this.props.onChange) {
        this.props.onChange(e);
      }
    });
  };

  render() {
    // Pass all the props except value and onChange to the input element
    const { value, onChange, ...rest } = this.props;
    return (
      <input
        {...rest}
        className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 pr-[40px] sm:text-sm sm:leading-6  outline-none shadow-none focus:ring focus:ring-white focus:ring-offset-0"
        placeholder="Enter Question here"
        ref={(input) => (this.input = input)}
        value={this.state.value}
        onChange={this.handleChange}
      />
    );
  }
}

export default TextInput;